import React, { useState } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { useKeenSlider } from 'keen-slider/react';
import * as Styles from './styles';
import { CarouselArrow } from './components/CarouselArrow';
/**
 * Componente Carousel do Design System OLX
 */
export const Carousel = _ref => {
  let {
    children,
    options,
    customArrows,
    hideArrowsOnMobile = true
  } = _ref;
  var _a, _b;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, carouselRef] = useKeenSlider(Object.assign(Object.assign({
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
      (options === null || options === void 0 ? void 0 : options.slideChanged) && options.slideChanged(slider);
    }
  }, options), {
    created(slider) {
      setLoaded(true);
      (options === null || options === void 0 ? void 0 : options.created) && options.created(slider);
    }
  }));
  React.useEffect(() => {
    var _a;
    (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.update();
  }, [carouselRef, options, children]);
  return React.createElement(Styles.Navigation, {
    "data-ds-component": "DS-Carousel"
  }, React.createElement(Styles.Wrapper, {
    ref: sliderRef,
    className: "keen-slider"
  }, React.Children.map(children, child => React.createElement("div", {
    className: "keen-slider__slide"
  }, child))), !customArrows && loaded && carouselRef.current && React.createElement(React.Fragment, null, React.createElement(CarouselArrow, {
    onClick: () => {
      var _a;
      return (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.prev();
    },
    disabled: currentSlide === 0,
    hideArrowsOnMobile: hideArrowsOnMobile
  }), React.createElement(CarouselArrow, {
    variant: "right",
    onClick: () => {
      var _a;
      return (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.next();
    },
    disabled: currentSlide === ((_b = (_a = carouselRef.current.track) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.maxIdx),
    hideArrowsOnMobile: hideArrowsOnMobile
  })), customArrows && customArrows({
    carouselRef,
    currentSlide
  }));
};
Carousel.displayName = 'Carousel';